export default "__VITE_ASSET__386a4247__"